module.exports = __webpack_public_path__ + "static/media/login-illustration.226dcafc.svg";